<template>
  <div class="site-pro-layout">
    <header class="site-pro-header">
      <section class="wl:flex-row-reverse">
        <NuxtLink
          :to="getLocalizedRoute(Routes.Account.SitePro)"
          class="flex xl:hidden align-end mr-auto hover:no-underline wl:mr-0 wl:ml-auto">
          <div class="flex items-center text-brand-primary gap-3">
            <i class="fa-solid fa-chevron-left text-lg" />
            <div class="font-bold text-sm">{{ t('common.back') }}</div>
          </div>
        </NuxtLink>
        <NuxtLink :to="getLocalizedRoute(Routes.Account.SitePro)">
          <img
            :src="logoPro"
            class="logo h-12 dark:invert"
            :alt="proTitleAttr"
            :class="{
              'h-8': isWhitelabel,
            }" />
        </NuxtLink>
      </section>
    </header>
    <div v-if="isWhitelabel" class="border-b border-neutral5 w-full" />
    <main class="flex flex-col min-h-md">
      <div class="background-block">
        <section class="section-header">
          <div class="section-header-inner">
            <div class="section-left">
              <h1 class="heading">
                <slot name="title" />
              </h1>
            </div>

            <div class="section-right">
              <SiteProBack />
            </div>
          </div>
        </section>
        <slot />
      </div>
    </main>
    <slot name="footer">
      <FooterJav v-if="isWhitelabel" is-pro />
      <ProFooter v-else />
    </slot>
  </div>
</template>

<script lang="ts" setup>
import ProFooter from '~/components/Page/Footer/ProFooter.vue'

import { Routes } from '~/enums/Routes'
import cleanTags from '~/utils/cleanTags'
import SiteProBack from '~/components/SitePro/SiteProBack.vue'
import getLocalizedRoute from '~/utils/getLocalizedRoute'

const { t } = useLang()
const { logoPro } = await useAssetManager().getLogos()

const proTitleAttr = computed(() => cleanTags(t('header.get_us_address')))
const { isWhitelabel } = useTheme()
</script>

<style lang="scss" scoped>
.site-pro-layout {
  .site-pro-header {
    @apply flex py-3 px-4 max-w-xlg mx-auto;
    section {
      @apply flex items-center max-w-xlg w-full gap-4 flex-wrap xl:flex-nowrap ml-auto mr-auto;
    }
  }

  .background-block {
    @apply flex-1 relative bg-neutral7 dark:bg-dmGray5 pb-4;
    .section-header {
      @apply py-4 xl:pt-[1.9375rem] xl:pb-[1.875rem] mx-auto max-w-xlg px-4;
      .section-header-inner {
        @apply flex gap-4 items-center w-full;
        .section-left {
          @apply flex basis-2/4 justify-start;
        }

        .section-right {
          @apply hidden xl:flex basis-2/4 justify-end;
        }
      }
    }
  }

  .back-button {
    @apply flex items-center gap-2 hover:cursor-pointer;

    &:hover {
      & > * {
        color: theme('colors.brand.primary') !important;
      }
    }
  }
}
</style>

<style lang="scss" scoped>
.wl .site-pro-layout {
  .section-header {
    @apply hidden;
  }

  .background-block {
    @apply bg-white;
  }
}
</style>
